import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import {MainListItems} from "./MenuBar";
import React from "react";
import {Drawer} from "@material-ui/core";

export default function SideMenu(props) {
    return (
        <Drawer
        variant="permanent"
        classes={{
            paper: clsx(props.classes.drawerPaper, !props.open && props.classes.drawerPaperClose),
        }}
        open={props.open}
    >
        <div className={props.classes.toolbarIcon}>
            <IconButton onClick={props.onClick}>
                <ChevronLeftIcon />
            </IconButton>
        </div>
        <Divider />
        <List>{MainListItems()}</List>
    </Drawer>
    );
}